import React, { Component } from "react";
import { Spin, message } from "antd";
import ForgotPassword from "./components/modals/ForgotPassword";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";

class Signin extends Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      type1: "password",
    };
  }
  // on change inputs
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // show hide password
  togglePassword = (num) => {
    if (num == "1") {
      this.setState({
        type1: this.state.type1 == "password" ? "text" : "password",
      });
    }
  };
  // sign in
  signinPlease = () => {
    if (!this.state.email) {
      message.warning("Email address is required");
      return;
    }
    if (!this.state.password) {
      message.warning("Password is required");
      return;
    }
    let params = {
      email: this.state.email,
      password: this.state.password,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.login(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);

          let name = "";
          if (response.data.first_name) {
            name = response.data.first_name;
          } else if (response.data.last_name) {
            name = response.data.last_name;
          } else if (response.data.participant_email) {
            name = response.data.participant_email;
          }

          localStorage.setItem("aptoken", response.data.token);
          localStorage.setItem("ap_name", name);
          localStorage.setItem("ap_id", response.data.participants_id);
          localStorage.setItem("ap_email", response.data.participant_email);

          if(RESEARCH_TYPE == "modality.ai"){
            localStorage.setItem("is_multiple_accounts_present", response.data.multiple_accounts_present);
            if(response.data.multiple_accounts_present==true){
              window.location.assign("/select-user-account");
              return;
            }else{
              localStorage.setItem(
                "ap_participants_accounts_id",
                response.data.participants_accounts_id
              );
            }
          }else{
            localStorage.setItem(
              "ap_participants_accounts_id",
              response.data.participants_accounts_id
            );
          }
          localStorage.setItem("ap_eals_id", response.data.eals_id);          
          localStorage.setItem("user_type", RESEARCH_TYPE);
          localStorage.setItem("ap_language", response.data.language);
          localStorage.setItem(
            "ap_relation_to_als",
            response.data.relation_to_als
          );
          // RESEARCH_TYPE!='modality.ai' &&
          if (response.data.consent_form_status == false) {
            window.location.assign("/consent-form");
          } else {
            window.location.assign("/dashboard");
          }
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <>
        <Header />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="authenitication-form">
                <div className="dark-side d-none d-sm-none d-md-none d-lg-block d-xl-block">
                  <img src={"./assets/images/dark-logo.jpg"} />
                  <p className="inner-text">
                    Our mission is to support efforts to care for ALS patients
                    and work to find treatments. We believe the technology will
                    be a key enabler for the innovation to end ALS, we are here
                    to bridge the gap between patients, research and technology.
                  </p>
                </div>
                <div className="right-sides-form">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <h2>Sign in</h2>
                        <div className="">
                          <Spin spinning={this.state.loading}>
                            <div className="form-wrapper">
                              <div className="form-field">
                                <label>
                                  <box-icon
                                    type="solid"
                                    name="envelope"
                                    color="#9e9e9e"
                                    size={
                                      window.innerWidth > 600 ? "23px" : "23px"
                                    }
                                    style={{
                                      marginTop:
                                        window.innerWidth > 600 ? 0 : -3,
                                      marginRight:
                                        window.innerWidth > 600 ? 12 : 9,
                                    }}
                                  ></box-icon>{" "}
                                  Your registered e-mail:
                                </label>
                                <input
                                  type="text"
                                  name="email"
                                  value={this.state.email}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <div className="form-field">
                                <label>
                                  <box-icon
                                    style={{
                                      marginTop:
                                        window.innerWidth > 600 ? 0 : -3,
                                      marginRight:
                                        window.innerWidth > 600 ? 12 : 9,
                                    }}
                                    name="lock-alt"
                                    type="solid"
                                    color="#9e9e9e"
                                    size={
                                      window.innerWidth > 600 ? "23px" : "23px"
                                    }
                                  ></box-icon>
                                  Password
                                </label>
                                <input
                                  type={this.state.type1}
                                  name="password"
                                  value={this.state.password}
                                  onChange={this.handleChange}
                                />
                                <div
                                  className="togglePassword"
                                  onClick={() => this.togglePassword("1")}
                                >
                                  {this.state.type1 == "password" ? (
                                    <div className="show-password-icon">
                                      <box-icon
                                        name="show"
                                        color="#ffa3a3"
                                      ></box-icon>
                                    </div>
                                  ) : (
                                    <div className="show-password-icon">
                                      <box-icon
                                        name="low-vision"
                                        color="#ffa3a3"
                                      ></box-icon>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <ForgotPassword />
                              <center>
                                <button
                                  type="button"
                                  className="submit-button full-width"
                                  onClick={() => this.signinPlease()}
                                >
                                  <box-icon
                                    name="log-in"
                                    color="#fff"
                                    size={"20px"}
                                  ></box-icon>
                                  &nbsp; LOGIN
                                </button>
                              </center>
                              {RESEARCH_TYPE == "modality.ai" ||
                                RESEARCH_TYPE == "ECAS Study" ||
                                (RESEARCH_TYPE == "LE Study" && (
                                  <span className="extra-link-with-text">
                                    New User? &nbsp;
                                    <a href="/create-new-account">
                                      Sign up new account
                                    </a>
                                  </span>
                                ))}
                            </div>
                          </Spin>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}
export default Signin;
